import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { ApiService, HttpMethod } from '../common/api.service';
import { AiChatQueryModel, AiChatQueryResponseModel } from './ai.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AiApiService extends ApiService
{
    constructor(http: HttpClient)
    {
        super(http);
    }

    queryChat(model: AiChatQueryModel): Observable<AiChatQueryResponseModel>
    {
        return this.apiRequest<any>(this.queryChatUrl, HttpMethod.Post, JSON.stringify(model))
            .pipe(map(json => new AiChatQueryResponseModel(json)));
    }

    rateQuery(queryId: number, rating: number): Observable<any>
    {
        return this.apiRequest<any>(this.rateQueryUrl, HttpMethod.Post, JSON.stringify({ QueryId: queryId, Rating: rating }));
    }

    // =========================================================================================================================================================
    // URLs
    // =========================================================================================================================================================
    /* tslint:disable:member-ordering */

    private get baseAiApiUrl(): string { return `${this.baseApiUrl}ai`; }
    get queryChatUrl(): string { return `${this.baseAiApiUrl}/queryChat`; }
    get rateQueryUrl(): string { return `${this.baseAiApiUrl}/rateQuery`; }
}
